import styled from 'styled-components';
export const StyledLabel = styled.label `
  position: relative;
  display: flex;
  height: 2.5rem;
  width: 4rem;
`;
